export const initSnackbar = {
    typeSnackbar: 'success',
    messageSnackbar: '',
    openSnackbar: false,
}

export const initWorkplanWarnings = {
    employeeWarnings: [],
    isLoading: false,
}

export const initAccessProfiles = {
    createTemplates: false,
    manageShiftlines: false,
    manageAssignments: false,
}